import { ProjectFragment } from 'gqlTypes'

export const formatProjectName = (project: ProjectFragment) => {
  if (project.type === 'PERSONAL_DRAFTS') {
    return 'My Drafts'
  }

  return project.name
}
